import { useEffect, useState } from 'react';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomeBanner from './components/HomeBanner';
import BelowBannerSection from './components/BelowBannerSection';
import About from './pages/About';
import MandatoryPublicDisclosure from './pages/MandatoryPublicDisclosure';
import Academics from './pages/Academics';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';

function useHashRoute() {
  const [hash, setHash] = useState(window.location.hash);

  useEffect(() => {
    const updateHash = () => setHash(window.location.hash);
    window.addEventListener('hashchange', updateHash);
    return () => window.removeEventListener('hashchange', updateHash);
  }, []);

  return hash;
}

function App() {
  const hash = useHashRoute();
  const isAboutPage = hash === '#about';
  const isDisclosurePage = hash === '#mandatory-public-disclosure';
  const isAcademicsPage = hash === '#academics';
  const renderContent = () => {
    switch (hash) {
      case '#about':
        return <About />;
      case '#academics':
        return <Academics />;
      case '#mandatory-public-disclosure':
        return <MandatoryPublicDisclosure />;
      case '#contact':
        return <Contact />;
      case '#gallery':
        return <Gallery />;
      default:
        return (
          <>
            <HomeBanner />
            <BelowBannerSection />
          </>
        );
    }
  };
  return (  
    <div className="App">
      <Header />
      {renderContent()}
      <Footer />
    </div>
  );
}

export default App;
